<div class="market-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-left">
      <h2>
        <i [class]="pageIcon"></i>
        {{ pageTitle }} - {{ getCurrentSegmentName() }}
      </h2>
      <p class="text-muted">{{ pageDescription }}</p>
    </div>
  </div>

  <!-- Filters Bar -->
  <div class="filters-bar">
    <div class="filters-row filters-row--compact">
      <div class="filter-group date-group">
        <label>Período</label>
        <div class="date-inputs">
          <p-datepicker
            [(ngModel)]="selectedDate.startDate"
            (ngModelChange)="onDateChange()"
            dateFormat="dd/mm/yy"
            placeholder="Data inicial"
            [showIcon]="true"
            iconDisplay="input"
            class="date-picker-input"
          />
          <span class="date-separator">até</span>
          <p-datepicker
            [(ngModel)]="selectedDate.endDate"
            (ngModelChange)="onDateChange()"
            dateFormat="dd/mm/yy"
            placeholder="Data final"
            [showIcon]="true"
            iconDisplay="input"
            class="date-picker-input"
          />
        </div>
      </div>
      <div class="filter-group filter-actions">
        <label>&nbsp;</label>
        <button class="btn-query" (click)="loadMetrics()" [disabled]="loading">
          <i class="fa-solid fa-magnifying-glass-chart"></i>
          Consultar
        </button>
      </div>
    </div>
  </div>

  <!-- Summary Cards -->
  <div class="summary-cards" *ngIf="loaded && !loading">
    <div class="summary-card depositos">
      <div class="summary-icon" title="Depósitos"><i class="fa-solid fa-money-bill-trend-up"></i></div>
      <div class="summary-info">
        <span class="summary-label">Depósitos</span>
        <span class="summary-value">{{ formatCurrency(grandTotals.valor_depositos) }}</span>
        <span class="summary-qty">{{ formatNumber(grandTotals.qtd_depositos) }} operações</span>
      </div>
    </div>
    <div class="summary-card saques">
      <div class="summary-icon" title="Saques"><i class="fa-solid fa-money-bill-wave"></i></div>
      <div class="summary-info">
        <span class="summary-label">Saques</span>
        <span class="summary-value">{{ formatCurrency(grandTotals.valor_saques) }}</span>
        <span class="summary-qty">{{ formatNumber(grandTotals.qtd_saques) }} operações</span>
      </div>
    </div>
    <div class="summary-card ftd">
      <div class="summary-icon" title="FTD (Primeiro Depósito)"><i class="fa-solid fa-star"></i></div>
      <div class="summary-info">
        <span class="summary-label">FTD</span>
        <span class="summary-value">{{ formatCurrency(grandTotals.valor_ftd) }}</span>
        <span class="summary-qty">{{ formatNumber(grandTotals.qtd_ftd) }} primeiros depósitos</span>
      </div>
    </div>
    <div class="summary-card novos">
      <div class="summary-icon" title="Novos Usuários"><i class="fa-solid fa-user-plus"></i></div>
      <div class="summary-info">
        <span class="summary-label">Novos Usuários</span>
        <span class="summary-value">{{ formatNumber(grandTotals.qtd_novos_usuarios) }}</span>
        <span class="summary-qty" *ngIf="!isAdminView">{{ getTotalSourcesCount() }} {{ getTotalSourcesCount() === 1 ? 'fonte' : 'fontes' }}</span>
        <span class="summary-qty" *ngIf="isAdminView">{{ affiliateGroups.length }} {{ affiliateGroups.length === 1 ? 'afiliado' : 'afiliados' }}</span>
      </div>
    </div>
    <div class="summary-card passagem">
      <div class="summary-icon" title="Taxa de Passagem (FTD / Novos Usuários)"><i class="fa-solid fa-filter-circle-dollar"></i></div>
      <div class="summary-info">
        <span class="summary-label">Passagem</span>
        <span class="summary-value">{{ formatPercent(grandTotals.passagem) }}</span>
        <span class="summary-qty">FTD / Novos Usuários</span>
      </div>
    </div>
    <div class="summary-card ticket-dep">
      <div class="summary-icon" title="Ticket Médio de Depósito"><i class="fa-solid fa-receipt"></i></div>
      <div class="summary-info">
        <span class="summary-label">Ticket Dep.</span>
        <span class="summary-value">{{ formatCurrency(grandTotals.ticket_dep) }}</span>
        <span class="summary-qty">média por depósito</span>
      </div>
    </div>
    <div class="summary-card ticket-ftd">
      <div class="summary-icon" title="Ticket Médio FTD"><i class="fa-solid fa-ticket"></i></div>
      <div class="summary-info">
        <span class="summary-label">Ticket FTD</span>
        <span class="summary-value">{{ formatCurrency(grandTotals.ticket_ftd) }}</span>
        <span class="summary-qty">média por primeiro depósito</span>
      </div>
    </div>
    <div class="summary-card retencao">
      <div class="summary-icon" title="Retenção (Depósitos / Valor FTD)"><i class="fa-solid fa-rotate"></i></div>
      <div class="summary-info">
        <span class="summary-label">Retenção<span class="summary-ref">(>3.0)</span></span>
        <span class="summary-value">{{ formatDecimal(grandTotals.retencao) }}x <span class="summary-equiv">≈ {{ formatXPct(grandTotals.retencao) }}</span></span>
        <span class="summary-qty">depósitos / valor FTD</span>
      </div>
    </div>
    <div class="summary-card investimento">
      <div class="summary-icon" title="Investimento"><i class="fa-solid fa-sack-dollar"></i></div>
      <div class="summary-info">
        <span class="summary-label">Investimento</span>
        <span class="summary-value">{{ formatCurrency(grandTotals.investimento) }}</span>
        <span class="summary-qty">total investido</span>
      </div>
    </div>
    <div class="summary-card volume" *ngIf="isVolumeSegment">
      <div class="summary-icon" title="Volume (mensagens enviadas)"><i class="fa-solid fa-comment-sms"></i></div>
      <div class="summary-info">
        <span class="summary-label">Volume</span>
        <span class="summary-value">{{ formatNumber(grandTotals.volume || 0) }}</span>
        <span class="summary-qty">mensagens enviadas</span>
      </div>
    </div>
    <div class="summary-card ggr">
      <div class="summary-icon" title="GGR Acumulado"><i class="fa-solid fa-chart-line"></i></div>
      <div class="summary-info">
        <span class="summary-label">GGR Acumulado</span>
        <span class="summary-value">{{ formatCurrency(grandTotals.ggr_acumulado) }}</span>
        <span class="summary-qty">receita bruta de jogo</span>
      </div>
    </div>
    <div class="summary-card cpa-registro">
      <div class="summary-icon" title="CPA Registro (Investimento / Novos Usuários)"><i class="fa-solid fa-user-tag"></i></div>
      <div class="summary-info">
        <span class="summary-label">CPA Registro</span>
        <span class="summary-value">{{ formatCurrency(grandTotals.cpa_registro) }}</span>
        <span class="summary-qty">custo por registro</span>
      </div>
    </div>
    <div class="summary-card cpa-ftd">
      <div class="summary-icon" title="CPA FTD (Investimento / FTDs)"><i class="fa-solid fa-bullseye"></i></div>
      <div class="summary-info">
        <span class="summary-label">CPA FTD</span>
        <span class="summary-value">{{ formatCurrency(grandTotals.cpa_ftd) }}</span>
        <span class="summary-qty">custo por primeiro depósito</span>
      </div>
    </div>
    <div class="summary-card roas-ftd">
      <div class="summary-icon" title="ROAS FTD (Valor FTD / Investimento)"><i class="fa-solid fa-arrow-trend-up"></i></div>
      <div class="summary-info">
        <span class="summary-label">ROAS FTD <span class="summary-ref">(1.5~2.0)</span></span>
        <span class="summary-value">{{ formatDecimal(grandTotals.roas_ftd) }}x <span class="summary-equiv">≈ {{ formatXPct(grandTotals.roas_ftd) }}</span></span>
        <span class="summary-qty">retorno sobre FTD</span>
      </div>
    </div>
    <div class="summary-card roas-dep">
      <div class="summary-icon" title="ROAS Dep (Depósitos / Investimento)"><i class="fa-solid fa-money-bill-trend-up"></i></div>
      <div class="summary-info">
        <span class="summary-label">ROAS Dep<span class="summary-ref">(4.0~7.0)</span></span>
        <span class="summary-value">{{ formatDecimal(grandTotals.roas_dep) }}x <span class="summary-equiv">≈ {{ formatXPct(grandTotals.roas_dep) }}</span></span>
        <span class="summary-qty">retorno sobre depósitos</span>
      </div>
    </div>
    <div class="summary-card roas-ggr">
      <div class="summary-icon" title="ROAS GGR (GGR / Investimento)"><i class="fa-solid fa-scale-balanced"></i></div>
      <div class="summary-info">
        <span class="summary-label">ROAS GGR<span class="summary-ref">(3.0~8.0)</span></span>
        <span class="summary-value">{{ formatDecimal(grandTotals.roas_ggr) }}x <span class="summary-equiv">≈ {{ formatXPct(grandTotals.roas_ggr) }}</span></span>
        <span class="summary-qty">retorno sobre GGR</span>
      </div>
    </div>
  </div>

  <!-- Loading Skeleton -->
  <div *ngIf="loading" class="skeleton-section">
    <p-skeleton height="80px" styleClass="mb-3" borderRadius="12px"></p-skeleton>
    <p-skeleton *ngFor="let item of [1,2,3,4,5,6]" height="48px" styleClass="mb-2" borderRadius="8px"></p-skeleton>
  </div>

  <!-- Initial State -->
  <div class="empty-state" *ngIf="!loaded && !loading">
    <i [class]="pageIcon"></i>
    <p>Selecione um segmento e clique em Consultar para visualizar as métricas.</p>
  </div>

  <!-- Groups Section -->
  <div class="groups-section" *ngIf="loaded && !loading">
    <div class="groups-header">
      <div class="groups-title">
        <i class="fa-solid fa-layer-group"></i>
        <span *ngIf="!isAdminView">{{ canalGroups.length }} {{ canalGroups.length === 1 ? 'canal' : 'canais' }} &nbsp;&middot;&nbsp; {{ dailySources.length }} {{ dailySources.length === 1 ? 'fonte' : 'fontes' }} &nbsp;&middot;&nbsp; {{ totalDailyRows.length }} dias</span>
        <span *ngIf="isAdminView">{{ affiliateGroups.length }} {{ affiliateGroups.length === 1 ? 'afiliado' : 'afiliados' }} &nbsp;&middot;&nbsp; {{ totalDailyRows.length }} dias</span>
      </div>
      <div class="groups-actions">
        <button class="btn-sm btn-action" (click)="expandAll()" pTooltip="Expandir todos" tooltipPosition="top">
          <i class="fa-solid fa-angles-down"></i>
        </button>
        <button class="btn-sm btn-action" (click)="collapseAll()" pTooltip="Colapsar todos" tooltipPosition="top">
          <i class="fa-solid fa-angles-up"></i>
        </button>
      </div>
    </div>

    <div class="accordion-container">

      <!-- TOTAL accordion -->
      <div class="accordion-group total-group" [class.is-expanded]="totalExpanded">
        <div class="accordion-header total-header" (click)="totalExpanded = !totalExpanded">
          <div class="accordion-header-left">
            <i class="accordion-chevron fa-solid"
               [class.fa-chevron-down]="!totalExpanded"
               [class.fa-chevron-up]="totalExpanded"></i>
            <div class="accordion-icon total-icon">
              <i class="fa-solid fa-layer-group"></i>
            </div>
            <div class="accordion-label">
              <span class="group-name">Total Consolidado</span>
              <span class="group-count">{{ totalDailyRows.length }} dias &middot; {{ dailySources.length }} fontes</span>
            </div>
          </div>
          <div class="accordion-chips">
            <div class="chip chip-dep" title="Depósitos">
              <i class="fa-solid fa-arrow-down"></i>
              <span>{{ formatCurrency(grandTotals.valor_depositos) }}</span>
              <small>({{ formatNumber(grandTotals.qtd_depositos) }})</small>
            </div>
            <div class="chip chip-saque" title="Saques">
              <i class="fa-solid fa-arrow-up"></i>
              <span>{{ formatCurrency(grandTotals.valor_saques) }}</span>
            </div>
            <div class="chip chip-ftd" title="FTD">
              <i class="fa-solid fa-star"></i>
              <span>{{ formatNumber(grandTotals.qtd_ftd) }}</span>
            </div>
            <div class="chip chip-ggr" title="GGR">
              <i class="fa-solid fa-chart-line"></i>
              <span>{{ formatCurrency(grandTotals.ggr_acumulado) }}</span>
            </div>
            <div class="chip chip-novos" title="Novos Usuários">
              <i class="fa-solid fa-user-plus"></i>
              <span>{{ formatNumber(grandTotals.qtd_novos_usuarios) }}</span>
            </div>
          </div>
        </div>
        <div class="accordion-body" *ngIf="totalExpanded">
          <!-- Grand Totals Summary -->
          <div class="utm-totals-summary">
            <div class="totals-grid">
              <div class="total-card">
                <div class="card-icon" style="background: #3b82f6;"><i class="fa-solid fa-coins"></i></div>
                <div class="card-content">
                  <span class="card-label">Investimento</span>
                  <span class="card-value">{{ formatCurrency(grandTotals.investimento) }}</span>
                </div>
              </div>
              <div class="total-card">
                <div class="card-icon" style="background: #8b5cf6;"><i class="fa-solid fa-user-tag"></i></div>
                <div class="card-content">
                  <span class="card-label">CPA Registro</span>
                  <span class="card-value">{{ formatCurrency(grandTotals.cpa_registro) }}</span>
                </div>
              </div>
              <div class="total-card">
                <div class="card-icon" style="background: #06b6d4;"><i class="fa-solid fa-star"></i></div>
                <div class="card-content">
                  <span class="card-label">CPA FTD</span>
                  <span class="card-value">{{ formatCurrency(grandTotals.cpa_ftd) }}</span>
                </div>
              </div>
              <div class="total-card">
                <div class="card-icon" style="background: #10b981;"><i class="fa-solid fa-trophy"></i></div>
                <div class="card-content">
                  <span class="card-label">ROAS FTD</span>
                  <span class="card-value">{{ formatDecimal(grandTotals.roas_ftd) }}%</span>
                </div>
              </div>
              <div class="total-card">
                <div class="card-icon" style="background: #f97316;"><i class="fa-solid fa-chart-line"></i></div>
                <div class="card-content">
                  <span class="card-label">ROAS Depósitos</span>
                  <span class="card-value">{{ formatDecimal(grandTotals.roas_dep) }}%</span>
                </div>
              </div>
              <div class="total-card">
                <div class="card-icon" style="background: #ec4899;"><i class="fa-solid fa-sack-dollar"></i></div>
                <div class="card-content">
                  <span class="card-label">ROAS GGR</span>
                  <span class="card-value">{{ formatDecimal(grandTotals.roas_ggr) }}%</span>
                </div>
              </div>
            </div>
          </div>

          <div class="daily-table-wrapper">
            <table class="daily-table">
              <thead>
                <tr>
                  <th class="col-date sortable" (click)="toggleSort('data')" [class.sorted]="sortField === 'data'">Data <i class="fa-solid" [ngClass]="getSortIcon('data')"></i></th>
                  <th class="col-num sortable" (click)="toggleSort('valor_depositos')" [class.sorted]="sortField === 'valor_depositos'">Depósitos <i class="fa-solid" [ngClass]="getSortIcon('valor_depositos')"></i></th>
                  <th class="col-num sortable" (click)="toggleSort('qtd_depositos')" [class.sorted]="sortField === 'qtd_depositos'">Qtd Dep <i class="fa-solid" [ngClass]="getSortIcon('qtd_depositos')"></i></th>
                  <th class="col-num sortable" (click)="toggleSort('valor_saques')" [class.sorted]="sortField === 'valor_saques'">Saques <i class="fa-solid" [ngClass]="getSortIcon('valor_saques')"></i></th>
                  <th class="col-num sortable" (click)="toggleSort('qtd_ftd')" [class.sorted]="sortField === 'qtd_ftd'">FTD <i class="fa-solid" [ngClass]="getSortIcon('qtd_ftd')"></i></th>
                  <th class="col-num sortable" (click)="toggleSort('valor_ftd')" [class.sorted]="sortField === 'valor_ftd'">R$ FTD <i class="fa-solid" [ngClass]="getSortIcon('valor_ftd')"></i></th>
                  <th class="col-num sortable" (click)="toggleSort('qtd_novos_usuarios')" [class.sorted]="sortField === 'qtd_novos_usuarios'">Novos <i class="fa-solid" [ngClass]="getSortIcon('qtd_novos_usuarios')"></i></th>
                  <th class="col-num sortable" (click)="toggleSort('passagem')" [class.sorted]="sortField === 'passagem'">Passagem <i class="fa-solid" [ngClass]="getSortIcon('passagem')"></i></th>
                  <th class="col-num sortable" (click)="toggleSort('ticket_dep')" [class.sorted]="sortField === 'ticket_dep'">Ticket Dep <i class="fa-solid" [ngClass]="getSortIcon('ticket_dep')"></i></th>
                  <th class="col-num sortable" (click)="toggleSort('retencao')" [class.sorted]="sortField === 'retencao'">Retenção <i class="fa-solid" [ngClass]="getSortIcon('retencao')"></i></th>
                  <th class="col-num sortable" (click)="toggleSort('ggr_acumulado')" [class.sorted]="sortField === 'ggr_acumulado'">GGR <i class="fa-solid" [ngClass]="getSortIcon('ggr_acumulado')"></i></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of totalDailyRows; let even = even" [class.row-even]="even">
                  <td class="col-date">{{ row.data }}</td>
                  <td class="col-num col-dep">{{ formatCurrency(row.valor_depositos) }}</td>
                  <td class="col-num col-muted">{{ formatNumber(row.qtd_depositos) }}</td>
                  <td class="col-num col-saque">{{ formatCurrency(row.valor_saques) }}</td>
                  <td class="col-num col-ftd">{{ formatNumber(row.qtd_ftd) }}</td>
                  <td class="col-num">{{ formatCurrency(row.valor_ftd) }}</td>
                  <td class="col-num col-muted">{{ formatNumber(row.qtd_novos_usuarios) }}</td>
                  <td class="col-num">{{ formatPercent(row.passagem) }}</td>
                  <td class="col-num">{{ formatCurrency(row.ticket_dep) }}</td>
                  <td class="col-num">{{ formatDecimal(row.retencao) }}x</td>
                  <td class="col-num" [class.col-ggr-pos]="row.ggr_acumulado >= 0" [class.col-ggr-neg]="row.ggr_acumulado < 0">
                    {{ formatCurrency(row.ggr_acumulado) }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="totals-row">
                  <td class="col-date">Total</td>
                  <td class="col-num col-dep">{{ formatCurrency(grandTotals.valor_depositos) }}</td>
                  <td class="col-num col-muted">{{ formatNumber(grandTotals.qtd_depositos) }}</td>
                  <td class="col-num col-saque">{{ formatCurrency(grandTotals.valor_saques) }}</td>
                  <td class="col-num col-ftd">{{ formatNumber(grandTotals.qtd_ftd) }}</td>
                  <td class="col-num">{{ formatCurrency(grandTotals.valor_ftd) }}</td>
                  <td class="col-num col-muted">{{ formatNumber(grandTotals.qtd_novos_usuarios) }}</td>
                  <td class="col-num">{{ formatPercent(grandTotals.passagem) }}</td>
                  <td class="col-num">{{ formatCurrency(grandTotals.ticket_dep) }}</td>
                  <td class="col-num">{{ formatDecimal(grandTotals.retencao) }}x</td>
                  <td class="col-num" [class.col-ggr-pos]="grandTotals.ggr_acumulado >= 0" [class.col-ggr-neg]="grandTotals.ggr_acumulado < 0">
                    {{ formatCurrency(grandTotals.ggr_acumulado) }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>

      <!-- Per-affiliate accordions (Admin View) -->
      <ng-container *ngIf="isAdminView">
        <ng-container *ngFor="let affiliate of affiliateGroups; let i = index">
          <div class="accordion-group source-group" [class.is-expanded]="isAffiliateExpanded(affiliate.afiliado_id)"
               [style.--source-color]="getGroupColor(i)">
            <div class="accordion-header source-header" (click)="toggleAffiliate(affiliate.afiliado_id)">
              <div class="accordion-header-left">
                <i class="accordion-chevron fa-solid"
                   [class.fa-chevron-down]="!isAffiliateExpanded(affiliate.afiliado_id)"
                   [class.fa-chevron-up]="isAffiliateExpanded(affiliate.afiliado_id)"></i>
                <div class="accordion-icon source-icon" [style.background]="getGroupColor(i)">
                  <i class="fa-solid fa-user-tie"></i>
                </div>
                <div class="accordion-label">
                  <span class="group-name">{{ affiliate.afiliado_nome }}</span>
                  <span class="group-count">{{ affiliate.canais.length }} {{ affiliate.canais.length === 1 ? 'canal' : 'canais' }} &middot; {{ getAffiliateSourcesCount(affiliate) }} {{ getAffiliateSourcesCount(affiliate) === 1 ? 'fonte' : 'fontes' }}</span>
                </div>
              </div>
              <div class="accordion-chips">
                <div class="chip chip-dep" title="Depósitos">
                  <i class="fa-solid fa-arrow-down"></i>
                  <span>{{ formatCurrency(getAffiliateTotals(affiliate).valor_depositos) }}</span>
                  <small>({{ formatNumber(getAffiliateTotals(affiliate).qtd_depositos) }})</small>
                </div>
                <div class="chip chip-saque" title="Saques">
                  <i class="fa-solid fa-arrow-up"></i>
                  <span>{{ formatCurrency(getAffiliateTotals(affiliate).valor_saques) }}</span>
                </div>
                <div class="chip chip-ftd" title="FTD">
                  <i class="fa-solid fa-star"></i>
                  <span>{{ formatNumber(getAffiliateTotals(affiliate).qtd_ftd) }}</span>
                </div>
                <div class="chip chip-ggr" title="GGR">
                  <i class="fa-solid fa-chart-line"></i>
                  <span>{{ formatCurrency(getAffiliateTotals(affiliate).ggr_acumulado) }}</span>
                </div>
                <div class="chip chip-novos" title="Novos Usuários">
                  <i class="fa-solid fa-user-plus"></i>
                  <span>{{ formatNumber(getAffiliateTotals(affiliate).qtd_novos_usuarios) }}</span>
                </div>
              </div>
            </div>

            <div class="accordion-body" *ngIf="isAffiliateExpanded(affiliate.afiliado_id)">
              <!-- Canal sub-accordions -->
              <ng-container *ngFor="let canal of affiliate.canais; let ci = index">
                <div class="accordion-group source-group canal-subgroup" [class.is-expanded]="isAffiliateCanalExpanded(affiliate.afiliado_id, canal.canal_id)"
                     [style.--source-color]="getGroupColor(ci)">
                  <div class="accordion-header source-header" (click)="toggleAffiliateCanal(affiliate.afiliado_id, canal.canal_id)">
                    <div class="accordion-header-left">
                      <i class="accordion-chevron fa-solid"
                         [class.fa-chevron-down]="!isAffiliateCanalExpanded(affiliate.afiliado_id, canal.canal_id)"
                         [class.fa-chevron-up]="isAffiliateCanalExpanded(affiliate.afiliado_id, canal.canal_id)"></i>
                      <div class="accordion-icon source-icon" [style.background]="getGroupColor(ci)">
                        <i class="fa-solid fa-tower-broadcast"></i>
                      </div>
                      <div class="accordion-label">
                        <span class="group-name">{{ canal.canal_descricao }}</span>
                        <span class="group-count">{{ canal.sources.length }} {{ canal.sources.length === 1 ? 'fonte' : 'fontes' }}</span>
                      </div>
                    </div>
                    <div class="accordion-chips">
                      <div class="chip chip-dep" title="Depósitos">
                        <i class="fa-solid fa-arrow-down"></i>
                        <span>{{ formatCurrency(getCanalTotals(canal).valor_depositos) }}</span>
                        <small>({{ formatNumber(getCanalTotals(canal).qtd_depositos) }})</small>
                      </div>
                      <div class="chip chip-saque" title="Saques">
                        <i class="fa-solid fa-arrow-up"></i>
                        <span>{{ formatCurrency(getCanalTotals(canal).valor_saques) }}</span>
                      </div>
                      <div class="chip chip-ftd" title="FTD">
                        <i class="fa-solid fa-star"></i>
                        <span>{{ formatNumber(getCanalTotals(canal).qtd_ftd) }}</span>
                      </div>
                      <div class="chip chip-ggr" title="GGR">
                        <i class="fa-solid fa-chart-line"></i>
                        <span>{{ formatCurrency(getCanalTotals(canal).ggr_acumulado) }}</span>
                      </div>
                      <div class="chip chip-novos" title="Novos Usuários">
                        <i class="fa-solid fa-user-plus"></i>
                        <span>{{ formatNumber(getCanalTotals(canal).qtd_novos_usuarios) }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-body" *ngIf="isAffiliateCanalExpanded(affiliate.afiliado_id, canal.canal_id)">
                    <!-- Source Tabs -->
                    <div class="source-tabs" [style.--tab-color]="getGroupColor(ci)">
                      <button
                        class="source-tab-btn"
                        [class.active]="getAffiliateCanalActiveTab(affiliate.afiliado_id, canal.canal_id) === 'total'"
                        (click)="setAffiliateCanalActiveTab(affiliate.afiliado_id, canal.canal_id, 'total')">
                        <i class="fa-solid fa-layer-group"></i> Total
                      </button>
                      <button
                        class="source-tab-btn"
                        *ngFor="let s of canal.sources"
                        [class.active]="getAffiliateCanalActiveTab(affiliate.afiliado_id, canal.canal_id) === s.utm_source"
                        (click)="setAffiliateCanalActiveTab(affiliate.afiliado_id, canal.canal_id, s.utm_source)">
                        {{ s.utm_source }}
                      </button>
                    </div>

                    <!-- Canal Total tab -->
                    <ng-container *ngIf="getAffiliateCanalActiveTab(affiliate.afiliado_id, canal.canal_id) === 'total'">
                      <div class="utm-totals-summary">
                        <div class="totals-grid">
                          <div class="total-card">
                            <div class="card-icon" style="background: #3b82f6;"><i class="fa-solid fa-coins"></i></div>
                            <div class="card-content">
                              <span class="card-label">Investimento</span>
                              <span class="card-value">{{ formatCurrency(getCanalTotals(canal).investimento) }}</span>
                            </div>
                          </div>
                          <div class="total-card">
                            <div class="card-icon" style="background: #8b5cf6;"><i class="fa-solid fa-user-tag"></i></div>
                            <div class="card-content">
                              <span class="card-label">CPA Registro</span>
                              <span class="card-value">{{ formatCurrency(getCanalTotals(canal).cpa_registro) }}</span>
                            </div>
                          </div>
                          <div class="total-card">
                            <div class="card-icon" style="background: #06b6d4;"><i class="fa-solid fa-star"></i></div>
                            <div class="card-content">
                              <span class="card-label">CPA FTD</span>
                              <span class="card-value">{{ formatCurrency(getCanalTotals(canal).cpa_ftd) }}</span>
                            </div>
                          </div>
                          <div class="total-card">
                            <div class="card-icon" style="background: #10b981;"><i class="fa-solid fa-trophy"></i></div>
                            <div class="card-content">
                              <span class="card-label">ROAS FTD</span>
                              <span class="card-value">{{ formatDecimal(getCanalTotals(canal).roas_ftd) }}%</span>
                            </div>
                          </div>
                          <div class="total-card">
                            <div class="card-icon" style="background: #f97316;"><i class="fa-solid fa-chart-line"></i></div>
                            <div class="card-content">
                              <span class="card-label">ROAS Depósitos</span>
                              <span class="card-value">{{ formatDecimal(getCanalTotals(canal).roas_dep) }}%</span>
                            </div>
                          </div>
                          <div class="total-card">
                            <div class="card-icon" style="background: #ec4899;"><i class="fa-solid fa-sack-dollar"></i></div>
                            <div class="card-content">
                              <span class="card-label">ROAS GGR</span>
                              <span class="card-value">{{ formatDecimal(getCanalTotals(canal).roas_ggr) }}%</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="daily-table-wrapper">
                        <table class="daily-table">
                          <thead>
                            <tr>
                              <th class="col-date sortable" (click)="toggleSort('data')" [class.sorted]="sortField === 'data'">Data <i class="fa-solid" [ngClass]="getSortIcon('data')"></i></th>
                              <th class="col-num sortable" (click)="toggleSort('valor_depositos')" [class.sorted]="sortField === 'valor_depositos'">Depósitos <i class="fa-solid" [ngClass]="getSortIcon('valor_depositos')"></i></th>
                              <th class="col-num sortable" (click)="toggleSort('qtd_depositos')" [class.sorted]="sortField === 'qtd_depositos'">Qtd Dep <i class="fa-solid" [ngClass]="getSortIcon('qtd_depositos')"></i></th>
                              <th class="col-num sortable" (click)="toggleSort('valor_saques')" [class.sorted]="sortField === 'valor_saques'">Saques <i class="fa-solid" [ngClass]="getSortIcon('valor_saques')"></i></th>
                              <th class="col-num sortable" (click)="toggleSort('qtd_ftd')" [class.sorted]="sortField === 'qtd_ftd'">FTD <i class="fa-solid" [ngClass]="getSortIcon('qtd_ftd')"></i></th>
                              <th class="col-num sortable" (click)="toggleSort('valor_ftd')" [class.sorted]="sortField === 'valor_ftd'">R$ FTD <i class="fa-solid" [ngClass]="getSortIcon('valor_ftd')"></i></th>
                              <th class="col-num sortable" (click)="toggleSort('qtd_novos_usuarios')" [class.sorted]="sortField === 'qtd_novos_usuarios'">Novos <i class="fa-solid" [ngClass]="getSortIcon('qtd_novos_usuarios')"></i></th>
                              <th class="col-num sortable" (click)="toggleSort('passagem')" [class.sorted]="sortField === 'passagem'">Passagem <i class="fa-solid" [ngClass]="getSortIcon('passagem')"></i></th>
                              <th class="col-num sortable" (click)="toggleSort('ticket_dep')" [class.sorted]="sortField === 'ticket_dep'">Ticket Dep <i class="fa-solid" [ngClass]="getSortIcon('ticket_dep')"></i></th>
                              <th class="col-num sortable" (click)="toggleSort('retencao')" [class.sorted]="sortField === 'retencao'">Retenção <i class="fa-solid" [ngClass]="getSortIcon('retencao')"></i></th>
                              <th class="col-num sortable" (click)="toggleSort('ggr_acumulado')" [class.sorted]="sortField === 'ggr_acumulado'">GGR <i class="fa-solid" [ngClass]="getSortIcon('ggr_acumulado')"></i></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let row of getCanalDailyRows(canal); let even = even" [class.row-even]="even">
                              <td class="col-date">{{ row.data }}</td>
                              <td class="col-num col-dep">{{ formatCurrency(row.valor_depositos) }}</td>
                              <td class="col-num col-muted">{{ formatNumber(row.qtd_depositos) }}</td>
                              <td class="col-num col-saque">{{ formatCurrency(row.valor_saques) }}</td>
                              <td class="col-num col-ftd">{{ formatNumber(row.qtd_ftd) }}</td>
                              <td class="col-num">{{ formatCurrency(row.valor_ftd) }}</td>
                              <td class="col-num col-muted">{{ formatNumber(row.qtd_novos_usuarios) }}</td>
                              <td class="col-num">{{ formatPercent(row.passagem) }}</td>
                              <td class="col-num">{{ formatCurrency(row.ticket_dep) }}</td>
                              <td class="col-num">{{ formatDecimal(row.retencao) }}x</td>
                              <td class="col-num" [class.col-ggr-pos]="row.ggr_acumulado >= 0" [class.col-ggr-neg]="row.ggr_acumulado < 0">
                                {{ formatCurrency(row.ggr_acumulado) }}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr class="totals-row">
                              <td class="col-date">Total</td>
                              <td class="col-num col-dep">{{ formatCurrency(getCanalTotals(canal).valor_depositos) }}</td>
                              <td class="col-num col-muted">{{ formatNumber(getCanalTotals(canal).qtd_depositos) }}</td>
                              <td class="col-num col-saque">{{ formatCurrency(getCanalTotals(canal).valor_saques) }}</td>
                              <td class="col-num col-ftd">{{ formatNumber(getCanalTotals(canal).qtd_ftd) }}</td>
                              <td class="col-num">{{ formatCurrency(getCanalTotals(canal).valor_ftd) }}</td>
                              <td class="col-num col-muted">{{ formatNumber(getCanalTotals(canal).qtd_novos_usuarios) }}</td>
                              <td class="col-num">{{ formatPercent(getCanalTotals(canal).passagem) }}</td>
                              <td class="col-num">{{ formatCurrency(getCanalTotals(canal).ticket_dep) }}</td>
                              <td class="col-num">{{ formatDecimal(getCanalTotals(canal).retencao) }}x</td>
                              <td class="col-num" [class.col-ggr-pos]="getCanalTotals(canal).ggr_acumulado >= 0" [class.col-ggr-neg]="getCanalTotals(canal).ggr_acumulado < 0">
                                {{ formatCurrency(getCanalTotals(canal).ggr_acumulado) }}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </ng-container>

                    <!-- Active source tab -->
                    <ng-container *ngFor="let s of canal.sources">
                      <ng-container *ngIf="getAffiliateCanalActiveTab(affiliate.afiliado_id, canal.canal_id) === s.utm_source">
                        <div class="utm-totals-summary">
                          <div class="totals-grid">
                            <div class="total-card">
                              <div class="card-icon" style="background: #3b82f6;"><i class="fa-solid fa-coins"></i></div>
                              <div class="card-content">
                                <span class="card-label">Investimento</span>
                                <span class="card-value">{{ formatCurrency(s.totais.investimento) }}</span>
                              </div>
                            </div>
                            <div class="total-card">
                              <div class="card-icon" style="background: #8b5cf6;"><i class="fa-solid fa-user-tag"></i></div>
                              <div class="card-content">
                                <span class="card-label">CPA Registro</span>
                                <span class="card-value">{{ formatCurrency(s.totais.cpa_registro) }}</span>
                              </div>
                            </div>
                            <div class="total-card">
                              <div class="card-icon" style="background: #06b6d4;"><i class="fa-solid fa-star"></i></div>
                              <div class="card-content">
                                <span class="card-label">CPA FTD</span>
                                <span class="card-value">{{ formatCurrency(s.totais.cpa_ftd) }}</span>
                              </div>
                            </div>
                            <div class="total-card">
                              <div class="card-icon" style="background: #10b981;"><i class="fa-solid fa-trophy"></i></div>
                              <div class="card-content">
                                <span class="card-label">ROAS FTD</span>
                                <span class="card-value">{{ formatDecimal(s.totais.roas_ftd) }}%</span>
                              </div>
                            </div>
                            <div class="total-card">
                              <div class="card-icon" style="background: #f97316;"><i class="fa-solid fa-chart-line"></i></div>
                              <div class="card-content">
                                <span class="card-label">ROAS Depósitos</span>
                                <span class="card-value">{{ formatDecimal(s.totais.roas_dep) }}%</span>
                              </div>
                            </div>
                            <div class="total-card">
                              <div class="card-icon" style="background: #ec4899;"><i class="fa-solid fa-sack-dollar"></i></div>
                              <div class="card-content">
                                <span class="card-label">ROAS GGR</span>
                                <span class="card-value">{{ formatDecimal(s.totais.roas_ggr) }}%</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="daily-table-wrapper">
                          <table class="daily-table">
                            <thead>
                              <tr>
                                <th class="col-date sortable" (click)="toggleSort('data')" [class.sorted]="sortField === 'data'">Data <i class="fa-solid" [ngClass]="getSortIcon('data')"></i></th>
                                <th class="col-num sortable" (click)="toggleSort('valor_depositos')" [class.sorted]="sortField === 'valor_depositos'">Depósitos <i class="fa-solid" [ngClass]="getSortIcon('valor_depositos')"></i></th>
                                <th class="col-num sortable" (click)="toggleSort('qtd_depositos')" [class.sorted]="sortField === 'qtd_depositos'">Qtd Dep <i class="fa-solid" [ngClass]="getSortIcon('qtd_depositos')"></i></th>
                                <th class="col-num sortable" (click)="toggleSort('valor_saques')" [class.sorted]="sortField === 'valor_saques'">Saques <i class="fa-solid" [ngClass]="getSortIcon('valor_saques')"></i></th>
                                <th class="col-num sortable" (click)="toggleSort('qtd_ftd')" [class.sorted]="sortField === 'qtd_ftd'">FTD <i class="fa-solid" [ngClass]="getSortIcon('qtd_ftd')"></i></th>
                                <th class="col-num sortable" (click)="toggleSort('valor_ftd')" [class.sorted]="sortField === 'valor_ftd'">R$ FTD <i class="fa-solid" [ngClass]="getSortIcon('valor_ftd')"></i></th>
                                <th class="col-num sortable" (click)="toggleSort('qtd_novos_usuarios')" [class.sorted]="sortField === 'qtd_novos_usuarios'">Novos <i class="fa-solid" [ngClass]="getSortIcon('qtd_novos_usuarios')"></i></th>
                                <th class="col-num sortable" (click)="toggleSort('passagem')" [class.sorted]="sortField === 'passagem'">Passagem <i class="fa-solid" [ngClass]="getSortIcon('passagem')"></i></th>
                                <th class="col-num sortable" (click)="toggleSort('ticket_dep')" [class.sorted]="sortField === 'ticket_dep'">Ticket Dep <i class="fa-solid" [ngClass]="getSortIcon('ticket_dep')"></i></th>
                                <th class="col-num sortable" (click)="toggleSort('retencao')" [class.sorted]="sortField === 'retencao'">Retenção <i class="fa-solid" [ngClass]="getSortIcon('retencao')"></i></th>
                                <th class="col-num sortable" (click)="toggleSort('ggr_acumulado')" [class.sorted]="sortField === 'ggr_acumulado'">GGR <i class="fa-solid" [ngClass]="getSortIcon('ggr_acumulado')"></i></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let row of s.dias; let even = even" [class.row-even]="even">
                                <td class="col-date">{{ row.data }}</td>
                                <td class="col-num col-dep">{{ formatCurrency(row.valor_depositos) }}</td>
                                <td class="col-num col-muted">{{ formatNumber(row.qtd_depositos) }}</td>
                                <td class="col-num col-saque">{{ formatCurrency(row.valor_saques) }}</td>
                                <td class="col-num col-ftd">{{ formatNumber(row.qtd_ftd) }}</td>
                                <td class="col-num">{{ formatCurrency(row.valor_ftd) }}</td>
                                <td class="col-num col-muted">{{ formatNumber(row.qtd_novos_usuarios) }}</td>
                                <td class="col-num">{{ formatPercent(row.passagem) }}</td>
                                <td class="col-num">{{ formatCurrency(row.ticket_dep) }}</td>
                                <td class="col-num">{{ formatDecimal(row.retencao) }}x</td>
                                <td class="col-num" [class.col-ggr-pos]="row.ggr_acumulado >= 0" [class.col-ggr-neg]="row.ggr_acumulado < 0">
                                  {{ formatCurrency(row.ggr_acumulado) }}
                                </td>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr class="totals-row">
                                <td class="col-date">Total</td>
                                <td class="col-num col-dep">{{ formatCurrency(s.totais.valor_depositos) }}</td>
                                <td class="col-num col-muted">{{ formatNumber(s.totais.qtd_depositos) }}</td>
                                <td class="col-num col-saque">{{ formatCurrency(s.totais.valor_saques) }}</td>
                                <td class="col-num col-ftd">{{ formatNumber(s.totais.qtd_ftd) }}</td>
                                <td class="col-num">{{ formatCurrency(s.totais.valor_ftd) }}</td>
                                <td class="col-num col-muted">{{ formatNumber(s.totais.qtd_novos_usuarios) }}</td>
                                <td class="col-num">{{ formatPercent(s.totais.passagem) }}</td>
                                <td class="col-num">{{ formatCurrency(s.totais.ticket_dep) }}</td>
                                <td class="col-num">{{ formatDecimal(s.totais.retencao) }}x</td>
                                <td class="col-num" [class.col-ggr-pos]="s.totais.ggr_acumulado >= 0" [class.col-ggr-neg]="s.totais.ggr_acumulado < 0">
                                  {{ formatCurrency(s.totais.ggr_acumulado) }}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- Per-canal accordions - Affiliate View -->
      <ng-container *ngIf="!isAdminView">
      <ng-container *ngFor="let canal of canalGroups; let i = index">
        <div class="accordion-group source-group" [class.is-expanded]="isCanalExpanded(canal.canal_id)"
             [style.--source-color]="getGroupColor(i)">
          <div class="accordion-header source-header" (click)="toggleCanal(canal.canal_id)">
            <div class="accordion-header-left">
              <i class="accordion-chevron fa-solid"
                 [class.fa-chevron-down]="!isCanalExpanded(canal.canal_id)"
                 [class.fa-chevron-up]="isCanalExpanded(canal.canal_id)"></i>
              <div class="accordion-icon source-icon" [style.background]="getGroupColor(i)">
                <i class="fa-solid fa-tower-broadcast"></i>
              </div>
              <div class="accordion-label">
                <span class="group-name">{{ canal.canal_descricao }}</span>
                <span class="group-count">{{ canal.sources.length }} {{ canal.sources.length === 1 ? 'fonte' : 'fontes' }}</span>
              </div>
            </div>
            <div class="accordion-chips">
              <div class="chip chip-dep" title="Depósitos">
                <i class="fa-solid fa-arrow-down"></i>
                <span>{{ formatCurrency(getCanalTotals(canal).valor_depositos) }}</span>
                <small>({{ formatNumber(getCanalTotals(canal).qtd_depositos) }})</small>
              </div>
              <div class="chip chip-saque" title="Saques">
                <i class="fa-solid fa-arrow-up"></i>
                <span>{{ formatCurrency(getCanalTotals(canal).valor_saques) }}</span>
              </div>
              <div class="chip chip-ftd" title="FTD">
                <i class="fa-solid fa-star"></i>
                <span>{{ formatNumber(getCanalTotals(canal).qtd_ftd) }}</span>
              </div>
              <div class="chip chip-ggr" title="GGR">
                <i class="fa-solid fa-chart-line"></i>
                <span>{{ formatCurrency(getCanalTotals(canal).ggr_acumulado) }}</span>
              </div>
              <div class="chip chip-novos" title="Novos Usuários">
                <i class="fa-solid fa-user-plus"></i>
                <span>{{ formatNumber(getCanalTotals(canal).qtd_novos_usuarios) }}</span>
              </div>
            </div>
          </div>

          <div class="accordion-body" *ngIf="isCanalExpanded(canal.canal_id)">
            <!-- Source Tabs -->
            <div class="source-tabs" [style.--tab-color]="getGroupColor(i)">
              <button
                class="source-tab-btn"
                [class.active]="getCanalActiveTab(canal.canal_id) === 'total'"
                (click)="setCanalActiveTab(canal.canal_id, 'total')">
                <i class="fa-solid fa-layer-group"></i> Total
              </button>
              <button
                class="source-tab-btn"
                *ngFor="let s of canal.sources"
                [class.active]="getCanalActiveTab(canal.canal_id) === s.utm_source"
                (click)="setCanalActiveTab(canal.canal_id, s.utm_source)">
                {{ s.utm_source }}
              </button>
            </div>

            <!-- Canal Total table -->
            <ng-container *ngIf="getCanalActiveTab(canal.canal_id) === 'total'">
              <div class="utm-totals-summary">
                <div class="totals-grid">
                  <div class="total-card">
                    <div class="card-icon" style="background: #3b82f6;"><i class="fa-solid fa-coins"></i></div>
                    <div class="card-content">
                      <span class="card-label">Investimento</span>
                      <span class="card-value">{{ formatCurrency(getCanalTotals(canal).investimento) }}</span>
                    </div>
                  </div>
                  <div class="total-card">
                    <div class="card-icon" style="background: #8b5cf6;"><i class="fa-solid fa-user-tag"></i></div>
                    <div class="card-content">
                      <span class="card-label">CPA Registro</span>
                      <span class="card-value">{{ formatCurrency(getCanalTotals(canal).cpa_registro) }}</span>
                    </div>
                  </div>
                  <div class="total-card">
                    <div class="card-icon" style="background: #06b6d4;"><i class="fa-solid fa-star"></i></div>
                    <div class="card-content">
                      <span class="card-label">CPA FTD</span>
                      <span class="card-value">{{ formatCurrency(getCanalTotals(canal).cpa_ftd) }}</span>
                    </div>
                  </div>
                  <div class="total-card">
                    <div class="card-icon" style="background: #10b981;"><i class="fa-solid fa-trophy"></i></div>
                    <div class="card-content">
                      <span class="card-label">ROAS FTD</span>
                      <span class="card-value">{{ formatDecimal(getCanalTotals(canal).roas_ftd) }}%</span>
                    </div>
                  </div>
                  <div class="total-card">
                    <div class="card-icon" style="background: #f97316;"><i class="fa-solid fa-chart-line"></i></div>
                    <div class="card-content">
                      <span class="card-label">ROAS Depósitos</span>
                      <span class="card-value">{{ formatDecimal(getCanalTotals(canal).roas_dep) }}%</span>
                    </div>
                  </div>
                  <div class="total-card">
                    <div class="card-icon" style="background: #ec4899;"><i class="fa-solid fa-sack-dollar"></i></div>
                    <div class="card-content">
                      <span class="card-label">ROAS GGR</span>
                      <span class="card-value">{{ formatDecimal(getCanalTotals(canal).roas_ggr) }}%</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="daily-table-wrapper">
                <table class="daily-table">
                <thead>
                  <tr>
                    <th class="col-date sortable" (click)="toggleSort('data')" [class.sorted]="sortField === 'data'">Data <i class="fa-solid" [ngClass]="getSortIcon('data')"></i></th>
                    <th class="col-num sortable" (click)="toggleSort('valor_depositos')" [class.sorted]="sortField === 'valor_depositos'">Depósitos <i class="fa-solid" [ngClass]="getSortIcon('valor_depositos')"></i></th>
                    <th class="col-num sortable" (click)="toggleSort('qtd_depositos')" [class.sorted]="sortField === 'qtd_depositos'">Qtd Dep <i class="fa-solid" [ngClass]="getSortIcon('qtd_depositos')"></i></th>
                    <th class="col-num sortable" (click)="toggleSort('valor_saques')" [class.sorted]="sortField === 'valor_saques'">Saques <i class="fa-solid" [ngClass]="getSortIcon('valor_saques')"></i></th>
                    <th class="col-num sortable" (click)="toggleSort('qtd_ftd')" [class.sorted]="sortField === 'qtd_ftd'">FTD <i class="fa-solid" [ngClass]="getSortIcon('qtd_ftd')"></i></th>
                    <th class="col-num sortable" (click)="toggleSort('valor_ftd')" [class.sorted]="sortField === 'valor_ftd'">R$ FTD <i class="fa-solid" [ngClass]="getSortIcon('valor_ftd')"></i></th>
                    <th class="col-num sortable" (click)="toggleSort('qtd_novos_usuarios')" [class.sorted]="sortField === 'qtd_novos_usuarios'">Novos <i class="fa-solid" [ngClass]="getSortIcon('qtd_novos_usuarios')"></i></th>
                    <th class="col-num sortable" (click)="toggleSort('passagem')" [class.sorted]="sortField === 'passagem'">Passagem <i class="fa-solid" [ngClass]="getSortIcon('passagem')"></i></th>
                    <th class="col-num sortable" (click)="toggleSort('ticket_dep')" [class.sorted]="sortField === 'ticket_dep'">Ticket Dep <i class="fa-solid" [ngClass]="getSortIcon('ticket_dep')"></i></th>
                    <th class="col-num sortable" (click)="toggleSort('retencao')" [class.sorted]="sortField === 'retencao'">Retenção <i class="fa-solid" [ngClass]="getSortIcon('retencao')"></i></th>
                    <th class="col-num sortable" (click)="toggleSort('ggr_acumulado')" [class.sorted]="sortField === 'ggr_acumulado'">GGR <i class="fa-solid" [ngClass]="getSortIcon('ggr_acumulado')"></i></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of getCanalDailyRows(canal); let even = even" [class.row-even]="even">
                    <td class="col-date">{{ row.data }}</td>
                    <td class="col-num col-dep">{{ formatCurrency(row.valor_depositos) }}</td>
                    <td class="col-num col-muted">{{ formatNumber(row.qtd_depositos) }}</td>
                    <td class="col-num col-saque">{{ formatCurrency(row.valor_saques) }}</td>
                    <td class="col-num col-ftd">{{ formatNumber(row.qtd_ftd) }}</td>
                    <td class="col-num">{{ formatCurrency(row.valor_ftd) }}</td>
                    <td class="col-num col-muted">{{ formatNumber(row.qtd_novos_usuarios) }}</td>
                    <td class="col-num">{{ formatPercent(row.passagem) }}</td>
                    <td class="col-num">{{ formatCurrency(row.ticket_dep) }}</td>
                    <td class="col-num">{{ formatDecimal(row.retencao) }}x</td>
                    <td class="col-num" [class.col-ggr-pos]="row.ggr_acumulado >= 0" [class.col-ggr-neg]="row.ggr_acumulado < 0">
                      {{ formatCurrency(row.ggr_acumulado) }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="totals-row">
                    <td class="col-date">Total</td>
                    <td class="col-num col-dep">{{ formatCurrency(getCanalTotals(canal).valor_depositos) }}</td>
                    <td class="col-num col-muted">{{ formatNumber(getCanalTotals(canal).qtd_depositos) }}</td>
                    <td class="col-num col-saque">{{ formatCurrency(getCanalTotals(canal).valor_saques) }}</td>
                    <td class="col-num col-ftd">{{ formatNumber(getCanalTotals(canal).qtd_ftd) }}</td>
                    <td class="col-num">{{ formatCurrency(getCanalTotals(canal).valor_ftd) }}</td>
                    <td class="col-num col-muted">{{ formatNumber(getCanalTotals(canal).qtd_novos_usuarios) }}</td>
                    <td class="col-num">{{ formatPercent(getCanalTotals(canal).passagem) }}</td>
                    <td class="col-num">{{ formatCurrency(getCanalTotals(canal).ticket_dep) }}</td>
                    <td class="col-num">{{ formatDecimal(getCanalTotals(canal).retencao) }}x</td>
                    <td class="col-num" [class.col-ggr-pos]="getCanalTotals(canal).ggr_acumulado >= 0" [class.col-ggr-neg]="getCanalTotals(canal).ggr_acumulado < 0">
                      {{ formatCurrency(getCanalTotals(canal).ggr_acumulado) }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            </ng-container>

            <!-- Active source table -->
            <ng-container *ngFor="let s of canal.sources">
              <ng-container *ngIf="getCanalActiveTab(canal.canal_id) === s.utm_source">

                <!-- UTM Totals Summary -->
                <div class="utm-totals-summary">
                  <div class="totals-grid">
                    <div class="total-card">
                      <div class="card-icon" style="background: #3b82f6;"><i class="fa-solid fa-coins"></i></div>
                      <div class="card-content">
                        <span class="card-label">Investimento</span>
                        <span class="card-value">{{ formatCurrency(s.totais.investimento) }}</span>
                      </div>
                    </div>
                    <div class="total-card">
                      <div class="card-icon" style="background: #8b5cf6;"><i class="fa-solid fa-user-tag"></i></div>
                      <div class="card-content">
                        <span class="card-label">CPA Registro</span>
                        <span class="card-value">{{ formatCurrency(s.totais.cpa_registro) }}</span>
                      </div>
                    </div>
                    <div class="total-card">
                      <div class="card-icon" style="background: #06b6d4;"><i class="fa-solid fa-star"></i></div>
                      <div class="card-content">
                        <span class="card-label">CPA FTD</span>
                        <span class="card-value">{{ formatCurrency(s.totais.cpa_ftd) }}</span>
                      </div>
                    </div>
                    <div class="total-card">
                      <div class="card-icon" style="background: #10b981;"><i class="fa-solid fa-trophy"></i></div>
                      <div class="card-content">
                        <span class="card-label">ROAS FTD</span>
                        <span class="card-value">{{ formatDecimal(s.totais.roas_ftd) }}%</span>
                      </div>
                    </div>
                    <div class="total-card">
                      <div class="card-icon" style="background: #f97316;"><i class="fa-solid fa-chart-line"></i></div>
                      <div class="card-content">
                        <span class="card-label">ROAS Depósitos</span>
                        <span class="card-value">{{ formatDecimal(s.totais.roas_dep) }}%</span>
                      </div>
                    </div>
                    <div class="total-card">
                      <div class="card-icon" style="background: #ec4899;"><i class="fa-solid fa-sack-dollar"></i></div>
                      <div class="card-content">
                        <span class="card-label">ROAS GGR</span>
                        <span class="card-value">{{ formatDecimal(s.totais.roas_ggr) }}%</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="daily-table-wrapper">
                  <table class="daily-table">
                    <thead>
                      <tr>
                        <th class="col-date sortable" (click)="toggleSort('data')" [class.sorted]="sortField === 'data'">Data <i class="fa-solid" [ngClass]="getSortIcon('data')"></i></th>
                        <th class="col-num sortable" (click)="toggleSort('valor_depositos')" [class.sorted]="sortField === 'valor_depositos'">Depósitos <i class="fa-solid" [ngClass]="getSortIcon('valor_depositos')"></i></th>
                        <th class="col-num sortable" (click)="toggleSort('qtd_depositos')" [class.sorted]="sortField === 'qtd_depositos'">Qtd Dep <i class="fa-solid" [ngClass]="getSortIcon('qtd_depositos')"></i></th>
                        <th class="col-num sortable" (click)="toggleSort('valor_saques')" [class.sorted]="sortField === 'valor_saques'">Saques <i class="fa-solid" [ngClass]="getSortIcon('valor_saques')"></i></th>
                        <th class="col-num sortable" (click)="toggleSort('qtd_ftd')" [class.sorted]="sortField === 'qtd_ftd'">FTD <i class="fa-solid" [ngClass]="getSortIcon('qtd_ftd')"></i></th>
                        <th class="col-num sortable" (click)="toggleSort('valor_ftd')" [class.sorted]="sortField === 'valor_ftd'">R$ FTD <i class="fa-solid" [ngClass]="getSortIcon('valor_ftd')"></i></th>
                        <th class="col-num sortable" (click)="toggleSort('qtd_novos_usuarios')" [class.sorted]="sortField === 'qtd_novos_usuarios'">Novos <i class="fa-solid" [ngClass]="getSortIcon('qtd_novos_usuarios')"></i></th>
                        <th class="col-num sortable" (click)="toggleSort('passagem')" [class.sorted]="sortField === 'passagem'">Passagem <i class="fa-solid" [ngClass]="getSortIcon('passagem')"></i></th>
                        <th class="col-num sortable" (click)="toggleSort('ticket_dep')" [class.sorted]="sortField === 'ticket_dep'">Ticket Dep <i class="fa-solid" [ngClass]="getSortIcon('ticket_dep')"></i></th>
                        <th class="col-num sortable" (click)="toggleSort('retencao')" [class.sorted]="sortField === 'retencao'">Retenção <i class="fa-solid" [ngClass]="getSortIcon('retencao')"></i></th>
                        <th class="col-num sortable" (click)="toggleSort('ggr_acumulado')" [class.sorted]="sortField === 'ggr_acumulado'">GGR <i class="fa-solid" [ngClass]="getSortIcon('ggr_acumulado')"></i></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of s.dias; let even = even" [class.row-even]="even">
                        <td class="col-date">{{ row.data }}</td>
                        <td class="col-num col-dep">{{ formatCurrency(row.valor_depositos) }}</td>
                        <td class="col-num col-muted">{{ formatNumber(row.qtd_depositos) }}</td>
                        <td class="col-num col-saque">{{ formatCurrency(row.valor_saques) }}</td>
                        <td class="col-num col-ftd">{{ formatNumber(row.qtd_ftd) }}</td>
                        <td class="col-num">{{ formatCurrency(row.valor_ftd) }}</td>
                        <td class="col-num col-muted">{{ formatNumber(row.qtd_novos_usuarios) }}</td>
                        <td class="col-num">{{ formatPercent(row.passagem) }}</td>
                        <td class="col-num">{{ formatCurrency(row.ticket_dep) }}</td>
                        <td class="col-num">{{ formatDecimal(row.retencao) }}x</td>
                        <td class="col-num" [class.col-ggr-pos]="row.ggr_acumulado >= 0" [class.col-ggr-neg]="row.ggr_acumulado < 0">
                          {{ formatCurrency(row.ggr_acumulado) }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="totals-row">
                        <td class="col-date">Total</td>
                        <td class="col-num col-dep">{{ formatCurrency(s.totais.valor_depositos) }}</td>
                        <td class="col-num col-muted">{{ formatNumber(s.totais.qtd_depositos) }}</td>
                        <td class="col-num col-saque">{{ formatCurrency(s.totais.valor_saques) }}</td>
                        <td class="col-num col-ftd">{{ formatNumber(s.totais.qtd_ftd) }}</td>
                        <td class="col-num">{{ formatCurrency(s.totais.valor_ftd) }}</td>
                        <td class="col-num col-muted">{{ formatNumber(s.totais.qtd_novos_usuarios) }}</td>
                        <td class="col-num">{{ formatPercent(s.totais.passagem) }}</td>
                        <td class="col-num">{{ formatCurrency(s.totais.ticket_dep) }}</td>
                        <td class="col-num">{{ formatDecimal(s.totais.retencao) }}x</td>
                        <td class="col-num" [class.col-ggr-pos]="s.totais.ggr_acumulado >= 0" [class.col-ggr-neg]="s.totais.ggr_acumulado < 0">
                          {{ formatCurrency(s.totais.ggr_acumulado) }}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
      </ng-container>

    </div>
  </div>
</div>
